import { teachersControllerChangeTeacherEntity } from 'api.gen'
import type { UserState } from 'utils/hooks/use-userInfo'
import { useEffect } from 'react'
import useToast from 'utils/hooks/use-toast'
import { notInArvoreKey } from './constants'

export function useNotInArvoreToast(user: UserState) {
  const { toastMessage } = useToast()

  useEffect(() => {
    if (
      user.isAdmin &&
      !user.isArvore &&
      !sessionStorage.getItem(notInArvoreKey)
    ) {
      sessionStorage.setItem(notInArvoreKey, 'true')
      toastMessage({
        type: 'warning',
        message: 'Seu root atual não é Árvore!',
        textButton: {
          text: 'Voltar para Árvore?',
          onClick: () => {
            teachersControllerChangeTeacherEntity({ entityId: 31 })
              .then(() => {
                sessionStorage.setItem(notInArvoreKey, '')
                location.reload()
              })
              .catch(() =>
                toastMessage({
                  type: 'error',
                  message: 'Desculpe, algo deu errado.'
                })
              )
          }
        },
        position: 'bottom-left'
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id])
}
